import httpClient from './http-client';
import mockPubService from './pub.service.mock';

let pubService;

if (process.env.NODE_ENV === 'development') {
  pubService = mockPubService;
} else {
  pubService = {
    getBnkList() {
      return httpClient.get('/pub/bnkList');
    },
  };
}

export default pubService;
